<template>
  <el-dialog
    :modal="false"
    class="login-dialog__web"
    :custom-class="customClass"
    :visible.sync="dialogVisible"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="true"
    @close="handleClose"
  >
    <div class="dialog-content">
      <div class="equity-list" v-if="equityConfigVisible">
        <div
          class="equity-list__title"
          :class="{
            'equity-list__title__few':
              equityConfig.equity_list && equityConfig.equity_list.length < 5,
          }"
        >
          <span>{{ equityConfig.settled_title }}</span>
        </div>
        <div
          class="equity-item"
          :class="{
            'equity-item__no__icon__style': !isHaveIcon,
          }"
          v-for="item in equityConfig.equity_list || []"
          :key="item.id"
        >
          <div
            class="equity-item__icon"
            :class="{ 'equity-item__icon__no_icon': !item.icon }"
          >
            <img :src="item.icon" alt="" />
          </div>
          <div class="equity-item__content">
            <div class="equity-item__title">{{ item.title }}</div>
            <div class="equity-item__instructions">{{ item.instructions }}</div>
          </div>
        </div>
      </div>
      <login-box v-if="dialogVisible"></login-box>
      <div class="close-btn" v-if="equityConfigVisible" @click="handleClose">
        <img
          class="close-icon"
          src="../../../assets/images/login/close.png"
          alt=""
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import LoginBox from "../Index.vue";
import { isH5 } from "@saas/components/src";
import { getEquity } from "@saas/server-api/src/settle-in";
export default {
  components: {
    LoginBox,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      default: () => {},
    },
    isShowEquity: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customClass() {
      if (this.isH5) {
        return "saas-web-dialog__h5";
      } else if (
        this.isShowEquity &&
        this.equityConfig.equity_list &&
        this.equityConfig.equity_list.length
      ) {
        return "saas-web-dialog__equity";
      } else {
        return "saas-web-dialog";
      }
    },
    equityConfigVisible() {
      return (
        this.isShowEquity &&
        !this.isH5 &&
        this.equityConfig.equity_list &&
        this.equityConfig.equity_list.length
      );
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          if (this.isShowEquity) {
            this.getEquity();
          }
          document.querySelector("#app").style.overflow = "hidden";
        } else {
          document.querySelector("#app").style.overflow = "auto";
        }
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      isH5: isH5(),
      // 权益配置
      equityConfig: {},
      // 权益配置是否包含图标
      isHaveIcon: false,
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.close();
      document.querySelector("#app").style.overflow = "auto";
    },
    getEquity() {
      getEquity().then((res) => {
        if (res.code === 1) {
          this.equityConfig = res.data || {
            settled_title: "",
            equity_list: [],
          };
          this.isHaveIcon = (this.equityConfig.equity_list || []).some(
            (item) => item.icon
          );
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-dialog__web {
  // 模糊背景
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    backdrop-filter: blur(7px); /* 设置高斯模糊效果 */
    background-color: rgba(0, 0, 0, 0.2); /* 背景颜色 */
  }
}
::v-deep .saas-web-dialog.el-dialog {
  margin: 0 auto !important;
  top: 50%;
  transform: translateY(-50%);
  width: 480px;
  height: 550px;
  background: #ffffff;
  border-radius: 24px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    width: 480px;
  }
  .el-dialog__close {
    font-weight: bold;
  }
}
::v-deep .saas-web-dialog__equity.el-dialog {
  margin: 0 auto !important;
  top: 50%;
  transform: translateY(-50%);
  width: 840px;
  height: 580px;
  background: #ffffff;
  border-radius: 24px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    width: 840px;
    height: 100%;
    overflow: hidden;
    .dialog-content {
      display: flex;
      flex-direction: row;
      height: 100%;
      overflow: hidden;
      border-radius: 24px;
      background-color: #fff;
      .equity-list {
        background: #f3fffa;
        background-image: url("../../../assets/images/login/bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 420px;
        .equity-list__title {
          margin-top: 52px;
          margin-bottom: 5px;
          font-weight: 500;
          font-size: 26px;
          color: #000000;
          height: 37px;
          line-height: 37px;
          text-align: center;
          span {
            position: relative;
            font-weight: 500;
            font-size: 26px;
            color: #000000;
            height: 37px;
            line-height: 37px;
            text-align: center;
            // 定义渐变色
            // background: linear-gradient(
            //   135deg,
            //   rgba(59, 255, 61, 0.5) 0%,
            //   rgba(0, 0, 0, 0.5) 100%
            // );
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
            &::after {
              content: "";
              position: absolute;
              top: 50%;
              right: -48px;
              transform: translateY(-50%);
              width: 44px;
              height: 24px;
              background: url("../../../assets/images/login/timeLimit.png");
              background-size: 100% 100%;
            }
          }
        }
        .equity-list__title__few {
          margin-bottom: 55px;
        }
        .equity-item {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
          .equity-item__icon {
            width: 50px;
            height: 50px;
            margin-right: 12px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .equity-item__icon__no_icon {
            visibility: hidden;
          }
          .equity-item__content {
            width: 240px;
            .equity-item__title {
              font-weight: 600;
              font-size: 16px;
              color: #0d1400;
              line-height: 22px;
            }
            .equity-item__instructions {
              margin-top: 4px;
              font-weight: 400;
              font-size: 12px;
              color: #575859;
              line-height: 17px;
            }
          }
        }
        .equity-item__no__icon__style {
          .equity-item__icon {
            display: none;
          }
        }
      }
      .login-container {
        flex: 1;
        .input-account {
          .close-btn {
            display: none;
          }
        }
        .input-container {
          width: 100%;
          min-width: 100%;
          align-items: flex-start;
          .comp-container {
            box-shadow: unset;
          }
        }
      }
      .close-btn {
        cursor: pointer;
        position: absolute;
        left: 20px;
        top: 20px;
        width: 20px;
        height: 20px;
      }
    }
  }
  .el-dialog__close {
    font-weight: bold;
  }
}
::v-deep .saas-web-dialog__h5 {
  margin: 0 auto !important;
  top: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    height: 100%;
    width: 100%;
  }
  .el-dialog__close {
    font-weight: bold;
  }
}
</style>
